'use strict'

export const CREATE_PLACE = 'places/CREATE_PLACE';
export const CREATE_PLACE_COMPLETED = 'places/CREATE_PLACE_COMPLETED';
export const SEARCH_PLACES = 'places/SEARCH_PLACES';
export const SEARCH_PLACES_COMPLETED = 'places/SEARCH_PLACES_COMPLETED';
export const GET_PLACES = 'places/GET_PLACES';
export const GET_PLACES_COMPLETED = 'places/GET_PLACES_COMPLETED';
export const GET_OFFICES = 'places/GET_OFFICES';
export const GET_OFFICES_COMPLETED = 'places/GET_OFFICES_COMPLETED';
